import { render, staticRenderFns } from "./video_1.vue?vue&type=template&id=68614c26&scoped=true&"
var script = {}
import style0 from "./video_1.vue?vue&type=style&index=0&id=68614c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68614c26",
  null
  
)

export default component.exports